function imgPathCheckUtil(path) {
  if (path[0] !== "/") {
    return "/" + path;
  }

  return path;
}

export { imgPathCheckUtil };
